import { apiClient } from "./client.js";
import { getUploaderToken } from "../lib/uploaderToken.js";

export function thumbnailUrl(mediaId: string): string {
  return `/api/media/${encodeURIComponent(mediaId)}/thumbnail`;
}

export function downloadUrl(mediaId: string): string {
  return `/api/media/${encodeURIComponent(mediaId)}/download`;
}

/** Browser-compatible source for <video> playback — falls back to the
 * original on the server side when no transcoded proxy is needed/ready.
 * Use downloadUrl() for actual downloads, which always serves the original. */
export function playbackUrl(mediaId: string): string {
  return `/api/media/${encodeURIComponent(mediaId)}/playback`;
}

/** Only succeeds if this browser sent the media in the first place — the
 * server checks the uploader token, this isn't just a hidden UI affordance. */
export function deleteOwnMedia(mediaId: string): Promise<{ deleted: boolean }> {
  return apiClient.delete(`/api/media/${encodeURIComponent(mediaId)}`, {
    headers: { "X-Uploader-Token": getUploaderToken() },
  });
}
